import type {State} from '../../../../../reducers/types'

import type {ErrorAnswer, CleanupHolderNode} from './Rules.types'
import {getKey} from './Rules.utils'

export const isAnyActionPerforming: (
  arg0: State,
  arg1: CleanupHolderNode | null | undefined,
) => boolean = ({cleanup}, holderNode) =>
  holderNode ? cleanup.isAnyActionPerforming[getKey(holderNode)] ?? false : false
export const isCustomErrorExists: (arg0: State) => ErrorAnswer | null | undefined = ({cleanup}) =>
  cleanup.errors ?? null
